import React, { useMemo } from 'react';
import { Progress, Rate } from 'tea-component';
import StarNum from '@/pages/opinion/components/StarBubble/StarNum';
import StarBubble from '@/pages/opinion/components/StarBubble';
import { getPercentageValue, getShowCount } from '@/pages/opinion/utils';
import { goStatsDetailAction } from '@/pages/opinion/pages/stats/Detail';
import { useIntl } from 'umi';
import PlatformTitle from '../PlatformTitle';
import CardCommon from '@/pages/opinion/components/CardCommon';
import './index.scss';
import '../gameStoreTitle.scss';
import { NO_DATE } from '@/pages/opinion/constants';
export function XboxGameStore({
  ratingKey,
  filter,
  ratingInfo,
  className,
  title,
  time,
  loading = false,
  height = 160,
  channel = 'xbox',
}: any) {
  const { formatMessage } = useIntl();
  const [mentions, detail, score, scoreText] = useMemo(() => {
    const { mentions, detail, score } = ratingInfo || {};
    return [
      mentions || 0,
      detail || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      score || 0,
      score?.toFixed(1),
    ];
  }, [ratingInfo]);

  return (
    <div className={'xbox-game-store ' + className}>
      <PlatformTitle
        className="channel-title-info"
        title={title}
        channelName={channel}
        iconTextMargin={6}
        size={16}
      >
        <p className="right-text">
          {time && !loading && score !== 0
            ? `${formatMessage({
                id: ratingKey === 'selected' ? NO_DATE.EMPTY : 'Up to',
              })} ${time}`
            : null}
        </p>
      </PlatformTitle>
      <CardCommon
        contentCard
        loading={loading}
        loadingHeight={height}
        empty={score === 0}
        // hasEmptyImg={false}
        emptyHeight={height}
        // hasEmptyTitle={false}
      >
        <div className="dbo-scorebox-content">
          <div className="dbo-scorebox-score">
            <div className="dbo-scorebox-scorebox">
              <div className="dbo-scorebox-num">{scoreText || 0}</div>
              {/* <div className="dbo-scorebox-rise">63.37%<SvgIcon type={true?'rising-arrow-icon':'down-arrow-icon'} className='dbo-scorebox-rise-icon' /></div> */}
            </div>
          </div>
          <div className="dbo-scorebox-reviewbox">
            <Rate readonly theme="primary" allowHalf value={score} />
            <div className="dbo-scorebox-text">
              {getShowCount(mentions)}{' '}
              {formatMessage({
                id: ratingKey === 'lifetime' ? 'Ratings-1' : 'Reviews-1',
              })}
            </div>
          </div>
        </div>
        <StarBubble
          isLifetime={ratingKey === 'lifetime'}
          detail={detail}
          mentions={mentions}
        >
          <div className="dbo-scorebox-subcontent">
            <StarNum />
            <div className="dbo-scorebox-progressbox">
              {[5, 4, 3, 2, 1].map((star) => (
                <Progress
                  className={`dbo-scorebox-progress star${star}`}
                  percent={getPercentageValue(detail[star], mentions) * 100}
                  strokeWidth={8}
                  onClick={() => {
                    goStatsDetailAction({
                      path: `/opinion/Feeds/Feeds?tab=gameStore`,
                      params: {
                        statsDetailType: 'feeds-gameStoreLine',
                        ...filter,
                        channel: ['xbox'],
                        channel_type: 'comments',
                        reviews_rating: ['' + star],
                      },
                      history,
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </StarBubble>
      </CardCommon>
    </div>
  );
}
